import type { AuthRepository, SnsSignInCommand } from '../repository/AuthRepository';
import type { SnsSignInResult } from '../entity/AuthTypes';

export class SnsSignInUseCase {
  constructor(private readonly repository: AuthRepository) {}

  async execute(command: SnsSignInCommand): Promise<SnsSignInResult> {
    if (!command.code?.trim()) throw new Error('code is required');
    if (!command.redirect_uri?.trim()) throw new Error('redirect_uri is required');
    return this.repository.snsSignIn(command);
  }
}
